import React from 'react';
import Staples from './Staples';

// Same layout as Staples, showing only the statement pieces
const Statements = ({ sortOrder }) => <Staples sortOrder={sortOrder} statements />;

export default Statements;
